export const QuestionMarkIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#333"
        d="M7 1.166a5.833 5.833 0 1 1 0 11.666A5.833 5.833 0 0 1 7 1.166Zm0 1.167a4.667 4.667 0 1 0 0 9.333 4.667 4.667 0 0 0 0-9.333Zm0 7a.583.583 0 1 1 0 1.166.583.583 0 0 1 0-1.166ZM7 3.79a2.115 2.115 0 0 1 .786 4.078.488.488 0 0 0-.178.117c-.026.029-.03.066-.03.105l.005.075a.583.583 0 0 1-1.163.068l-.004-.068V8.02c0-.672.543-1.076.936-1.234a.948.948 0 1 0-1.3-.88.583.583 0 0 1-1.167 0A2.115 2.115 0 0 1 6.999 3.79Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const DoubleTagIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#333" d="M7.473 14.001 14 7.475V9.36l-6.527 6.527L1.447 9.86l.946-.94 5.08 5.08Z" />
    <path
      fill="#333"
      d="m14 6.027-6.527 6.526-6.026-6.026L7.973 0H14v6.027ZM11.167 2a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z"
    />
  </svg>
);

export const ReviewStar = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M16 0H0v16h16V0Z" />
    </mask>
    <g mask="url(#a)">
      <path fill={color} d="M16 0H0v16h16V0Z" />
      <path fill="url(#b)" d="m11.982 13.896-1.41-4.424-2.604 1.868 3.754 2.745c.13.097.31-.032.26-.188v-.001Z" />
      <path
        fill="#fff"
        d="m3.93 13.845 1.417-4.29a.168.168 0 0 0-.06-.188l-3.633-2.68a.17.17 0 0 1 .1-.305l4.644.02h.004l1.475-4.404A.17.17 0 0 1 8.199 2l1.363 4.285c.022.07.086.118.159.118l4.527.037c.163 0 .23.21.097.306l-3.77 2.724-.068.048-.039.028-2.501 1.789-3.778 2.7c-.133.095-.31-.036-.259-.192v.002Z"
      />
    </g>
    <defs>
      <linearGradient id="b" x1={12.752} x2={8.877} y1={12.979} y2={10.116} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={0.34} stopColor="#FCFCFC" />
        <stop offset={0.52} stopColor="#F4F4F4" />
        <stop offset={0.66} stopColor="#E7E7E7" />
        <stop offset={0.78} stopColor="#D4D4D4" />
        <stop offset={0.89} stopColor="#BBB" />
        <stop offset={0.99} stopColor="#9D9D9D" />
        <stop offset={1} stopColor="#999" />
      </linearGradient>
    </defs>
  </svg>
);

export const ShoppingBagIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#333"
      fillRule="evenodd"
      d="M6.537 5.95H5.006a2.017 2.017 0 0 0-2.012 1.874l-.988 13.831a2.017 2.017 0 0 0 2.012 2.16h15.966a2.018 2.018 0 0 0 2.012-2.16l-.988-13.831a2.017 2.017 0 0 0-2.012-1.874h-1.52v-.288A5.475 5.475 0 0 0 12 .188c-2.913 0-5.606 2.32-5.475 5.474l.011.288Zm10.939 1.73v4.322a.865.865 0 0 1-1.73 0V7.679H8.256v4.323a.865.865 0 0 1-1.729 0s.075-2.02.05-4.323h-1.57a.288.288 0 0 0-.287.268l-.989 13.83a.288.288 0 0 0 .288.31h15.966a.29.29 0 0 0 .287-.31l-.988-13.83a.288.288 0 0 0-.287-.268h-1.52Zm-1.73-1.73v-.288a3.746 3.746 0 1 0-7.491 0v.288h7.492Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronDownIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#828282"
      d="M6 9a.732.732 0 0 1-.52-.216L.965 4.258a.738.738 0 0 1 0-1.042.734.734 0 0 1 1.04 0L6 7.22l3.995-4.005a.734.734 0 0 1 1.04 0 .738.738 0 0 1 0 1.042L6.52 8.784A.732.732 0 0 1 6 9Z"
    />
  </svg>
);

export const ChevronDownBigIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#828282"
      d="M8 12a.976.976 0 0 1-.693-.288l-6.02-6.034a.984.984 0 0 1 0-1.39.979.979 0 0 1 1.387 0L8 9.628l5.326-5.34a.979.979 0 0 1 1.387 0 .984.984 0 0 1 0 1.39l-6.02 6.035A.976.976 0 0 1 8 12Z"
    />
  </svg>
);

export const ClockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={20} fill="none" {...props}>
    <path
      fill="#333"
      d="M9.5 2.083a7.917 7.917 0 1 0 0 15.834 7.917 7.917 0 0 0 0-15.834Zm3.325 11.242-4.117-2.533v-4.75h1.188v4.116l3.562 2.138-.633 1.029Z"
    />
  </svg>
);

export const AmericanFlagIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path fill="#F0F0F0" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" />
      <path
        fill="#D80027"
        d="M7.652 8H16a8.01 8.01 0 0 0-.275-2.087H7.652V8ZM7.652 3.826h7.174A8.043 8.043 0 0 0 12.98 1.74H7.652v2.087ZM8 16c1.883 0 3.614-.65 4.98-1.74H3.02A7.966 7.966 0 0 0 8 16ZM1.174 12.174h13.652a7.952 7.952 0 0 0 .898-2.087H.276c.2.744.505 1.445.898 2.087Z"
      />
      <path
        fill="#0052B4"
        d="M3.706 1.25h.729l-.678.492.259.797-.678-.493-.679.493.224-.689a8.044 8.044 0 0 0-1.551 1.73h.233l-.431.313a7.984 7.984 0 0 0-.194.342l.206.635-.384-.28C.666 4.793.579 5 .5 5.211l.227.7h.838l-.678.492.26.797-.679-.493-.406.295C.022 7.33 0 7.662 0 8h8V0C6.42 0 4.946.458 3.706 1.25Zm.31 5.95-.678-.493-.679.493.26-.797-.679-.493h.839l.259-.797.259.797h.838l-.678.493.259.797Zm-.26-3.128.26.798-.678-.493-.679.493.26-.798-.679-.492h.839l.259-.797.259.797h.838l-.678.492ZM6.887 7.2l-.679-.493-.678.493.26-.797-.679-.493h.838l.26-.797.258.797h.838l-.678.493.26.797Zm-.26-3.128.26.798-.679-.493-.678.493.26-.798-.679-.492h.838l.26-.797.258.797h.838l-.678.492Zm0-2.33.26.797-.679-.493-.678.493.26-.797-.679-.493h.838l.26-.797.258.797h.838l-.678.493Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const YellowStar = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5754 5.71885L10.6567 4.96639L8.45208 0.263392C8.28741 -0.0877974 7.71208 -0.0877974 7.54741 0.263392L5.34342 4.96639L0.424765 5.71885C0.0207661 5.78094 -0.140567 6.27301 0.142766 6.56344L3.71609 10.2316L2.87143 15.4173C2.80409 15.8292 3.24342 16.1384 3.60676 15.9361L8.00008 13.5044L12.3934 15.9367C12.7534 16.137 13.1967 15.8339 13.1287 15.418L12.2841 10.2322L15.8574 6.56411C16.1407 6.27301 15.9787 5.78094 15.5754 5.71885Z"
        fill="#F1BF0B"
      />
    </svg>
  );
};

export const BenefitCheck = ({ fill }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C11.3132 20 12.6136 19.7413 13.8268 19.2388C15.0401 18.7362 16.1425 17.9997 17.0711 17.0711C17.9997 16.1425 18.7362 15.0401 19.2388 13.8268C19.7413 12.6136 20 11.3132 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 -1.95685e-08 10 0C7.34784 3.95203e-08 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM9.74222 14.0444L15.2978 7.37778L13.5911 5.95556L8.81333 11.6878L6.34111 9.21445L4.77 10.7856L8.10333 14.1189L8.96333 14.9789L9.74222 14.0444Z"
        fill={fill}
      />
    </svg>
  );
};

export const AvatarsCheckmark = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_997_31593)">
        <path
          d="M3.97553 8.26931C3.89201 8.35333 3.77805 8.4002 3.65968 8.4002C3.54131 8.4002 3.42735 8.35333 3.34383 8.26931L0.821335 5.74641C0.559555 5.48463 0.559555 5.06014 0.821335 4.79885L1.13719 4.48291C1.39905 4.22114 1.82305 4.22114 2.08483 4.48291L3.65968 6.05785L7.91515 1.80229C8.17701 1.54051 8.60142 1.54051 8.86279 1.80229L9.17865 2.11823C9.44043 2.38001 9.44043 2.80442 9.17865 3.06579L3.97553 8.26931Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_997_31593">
          <rect width="8.75" height="8.75" fill="white" transform="translate(0.625 0.625)" />
        </clipPath>
      </defs>
    </svg>
  );
};
